module.exports = __webpack_public_path__ + "static/media/view6.2288496d.jpg";